type Announcement = Omit<StoredAnnouncement, 'collapsed'>

export const useActiveAnnouncement = () => {
  const licensedTerritory = useLicensedTerritory({ raw: true })

  const { announcementByKey, deleteAllAnnouncements, setAnnouncementByKey } =
    useActiveAnnouncementStore()

  const { clearActiveAnnouncementsCache } = useApolloCache()

  const { load, onResult: onQueryResult } = useActiveAnnouncementLazyQuery(
    {
      licensedTerritory,
    },
    {
      fetchPolicy: 'cache-first',
    },
  )

  onQueryResult((payload) => {
    if (!payload.data) return
    activeAnnouncement.value = payload.data.activeAnnouncement

    if (!activeAnnouncement.value) {
      deleteAllAnnouncements()
      return
    }

    setAnnouncementByKey(licensedTerritory, {
      ...activeAnnouncement.value,
      collapsed: announcementByKey(licensedTerritory)?.collapsed ?? false,
    })
  })

  const { onResult: onSubscriptionResult } = useAnnouncementChangedSubscription(
    {
      licensedTerritory,
    },
    {
      fetchPolicy: 'cache-first',
    },
  )

  const activeAnnouncement = ref<Maybe<Announcement> | undefined>(
    announcementByKey(licensedTerritory),
  )

  onSubscriptionResult((payload) => {
    clearActiveAnnouncementsCache(true)

    activeAnnouncement.value = payload.data?.announcementChanged

    if (!activeAnnouncement.value) return

    if (!activeAnnouncement.value.active) {
      deleteAllAnnouncements()
      return
    }

    setAnnouncementByKey(licensedTerritory, {
      ...activeAnnouncement.value,
      collapsed: announcementByKey(licensedTerritory)?.collapsed ?? false,
    })
  })

  const isCollapsed = computed(() => {
    if (!activeAnnouncement.value) return false

    return announcementByKey(licensedTerritory)?.collapsed
  })

  const startSubscription = () => load()

  onMounted(() => load())

  return {
    activeAnnouncement,
    isCollapsed,
    licensedTerritory,
    setAnnouncementByKey,
    startSubscription,
  }
}
